const $inject = ['dataService'];

const lbaSubHeadingCtrl = function (dataService) {
  let vm = this;
  vm.data = dataService.data.activeItem;
};

lbaSubHeadingCtrl.$inject = $inject;

export default lbaSubHeadingCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaSubHeading/lbaSubHeadingCtrl.js